const v38 = (state: any) => {
  const { 'Invoice Number': _invoiceNumber, ...invoicesTable } =
    state.options.tableViews.invoicesTable;

  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        invoicesTable,
      },
    },
  };
};

export default v38;
